import React from "react";
//#region types
import { OwnersWidgetProps } from "models/propTypes/holdingRegisterPropTypes";
import { CompanyEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ShareholderList from "./shareholderView";
import OwnershipStructureView from "./ownershipStructureView";
//#endregion

const OwnersWidget: React.FC<OwnersWidgetProps> = (props) => {
  const { switchType, shapshotDate } = props;

  return (
    <Grid item container columnGap={2}>
      {switchType === CompanyEnums.OwnersViewType.Shareholder ? (
        <ShareholderList snapshotDate={shapshotDate} />
      ) : (
        <OwnershipStructureView snapshotDate={shapshotDate} />
      )}
    </Grid>
  );
};

export default OwnersWidget;
